import { render, staticRenderFns } from "./EngagementProjectBox.vue?vue&type=template&id=7bab5852&scoped=true&"
import script from "./EngagementProjectBox.vue?vue&type=script&lang=js&"
export * from "./EngagementProjectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bab5852",
  null
  
)

export default component.exports